.stepper {
  font-family: 'Lato';
  font-weight: 400;

  &.vertical {
    .steps {
      display: flex;
      flex-direction: column;

      .step {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .marker {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: #ccc;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
          font-weight: 400;
        }

        .label {
          font-size: 14px;
          font-weight: 400;
        }

        &.active {
          .marker {
            background-color: var(--primary-main);
            color: #fff;
          }
        }
      }
    }
  }

  &.horizontal {
    .steps {
      display: flex;
      flex-direction: row;
      align-items: center;

      .step {
        display: flex;
        align-items: center;
        margin-right: 20px;

        .marker {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: #ccc;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 400;
          margin-right: 10px;
        }

        .label {
          font-size: 14px;
          font-weight: 400;
        }

        &.active {
          .marker {
            background-color: var(--primary-main);
            color: #fff;
          }
        }
      }
    }
  }

  .step-line {
    border: none;
    height: 1px;
    background-color: #000;
    margin: 0.5rem 0;
  }

  .navigation {
    margin-top: 20px;

    .btn-previous,
    .btn-next {
      padding: 8px 16px;
      background-color: var(--primary-main);
      color: #fff;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      margin-right: 10px;
    }

    .btn-previous[disabled],
    .btn-next[disabled] {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
